"use client"

import { Toaster } from "sonner"

export function ToastProvider() {
  return (
    <Toaster
      position="top-right"
      offset="80px"
      closeButton
      toastOptions={{
        classNames: {
          toast: "bg-white dark:bg-slate-800 border border-border dark:border-slate-700 shadow-lg rounded-lg !pr-10",
          title: "text-foreground dark:text-slate-100 font-medium",
          description: "text-muted-foreground dark:text-slate-400",
          actionButton: "bg-slate-900 dark:bg-slate-100 text-white dark:text-slate-900",
          cancelButton: "bg-muted dark:bg-slate-800 text-foreground dark:text-slate-100",
          closeButton: "!bg-transparent !border-0 !shadow-none !text-muted-foreground dark:!text-muted-foreground hover:!text-foreground dark:hover:!text-slate-100 !absolute !right-3 !top-1/2 !-translate-y-1/2 !left-auto",
          success: "!bg-green-50 dark:bg-green-950 dark:!bg-green-950 !border-green-200 dark:border-green-800 dark:!border-green-900 !text-green-900 dark:!text-green-100 [&_svg:first-child]:!text-green-600 dark:[&_svg:first-child]:!text-green-400",
          error: "!bg-red-50 dark:bg-red-950 dark:!bg-red-950 !border-red-200 dark:border-red-800 dark:!border-red-900 !text-red-900 dark:!text-red-100 [&_svg:first-child]:!text-red-600 dark:[&_svg:first-child]:!text-red-400",
          warning: "!bg-yellow-50 dark:bg-yellow-950 dark:!bg-yellow-950 !border-yellow-200 dark:border-yellow-800 dark:!border-yellow-900 !text-yellow-900 dark:!text-yellow-100 [&_svg:first-child]:!text-yellow-600 dark:[&_svg:first-child]:!text-yellow-500",
          info: "!bg-blue-50 dark:bg-blue-950 dark:!bg-blue-950 !border-blue-200 dark:border-blue-800 dark:!border-blue-900 !text-blue-900 dark:!text-blue-100 [&_svg:first-child]:!text-blue-600 dark:[&_svg:first-child]:!text-blue-400",
        },
      }}
    />
  )
}
